export const USER_INFO = 'USER_INFO';
export const RESET = 'RESET';
export const USER_UPDATE = 'USER_UPDATE';
export const ADD_TO_NETWORK = 'ADD_TO_NETWORK';
export const EDIT_SPAM_LIST = 'EDIT_SPAM_LIST';
export const UNANSWERED_NETWORK_REQUEST_COUNT = 'UNANSWERED_NETWORK_REQUEST_COUNT';
export const DECREMENT_UNANSWERED_NETWORK_REQUEST_COUNT = 'DECREMENT_UNANSWERED_NETWORK_REQUEST_COUNT';
